export const formatRut = (value) => {
    if (!value) return '';
    // 1. Limpiar todo lo que no sea un número o K.
    const cleanValue = value.replace(/[^0-9kK]/g, '').toUpperCase();
    
    // 2. Limitar la longitud del valor limpio a 9 caracteres.
    const limitedCleanValue = cleanValue.slice(0, 9);

    if (!limitedCleanValue) return '';

    // 3. Aplicar formato al valor limpio y limitado.
    let body = limitedCleanValue.slice(0, -1);
    let verifier = limitedCleanValue.slice(-1);
    body = body.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    
    return `${body}-${verifier}`;
};

export const formatPhone = (value) => {
    if (!value) return '';
    const cleanValue = value.replace(/\D/g, '');
    if (!cleanValue) return '';
    const formatted = cleanValue.slice(0, 9);
    if (formatted.length > 5) {
        return `${formatted.slice(0, 1)} ${formatted.slice(1, 5)} ${formatted.slice(5)}`;
    }
    if (formatted.length > 1) {
        return `${formatted.slice(0, 1)} ${formatted.slice(1)}`;
    }
    return formatted;
};

export const formatCurrency = (value) => {
    if (isNaN(value)) return '$ 0';
    return new Intl.NumberFormat('es-CL', { style: 'currency', currency: 'CLP' }).format(value);
};
